module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-widget"
  }, [_c('div', {
    staticClass: "chat-button",
    class: {
      'has-unread': _vm.unreadCount > 0
    },
    on: {
      "click": _vm.onToggleChat
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), (_vm.unreadCount > 0) ? _c('span', {
    staticClass: "chat-badge"
  }, [_vm._v(_vm._s(_vm.unreadCount > 99 ? '99+' : _vm.unreadCount))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.isChatOpen) ? _c('chat-window', {
    on: {
      "close": _vm.closeChat
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f580d2f6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/chat-plugin/components/ChatWidget.vue
// module id = 2093
// module chunks = 18